import { render, staticRenderFns } from "./color-marker.vue?vue&type=template&id=9b7d577e&"
import script from "./color-marker.vue?vue&type=script&lang=js&"
export * from "./color-marker.vue?vue&type=script&lang=js&"
import style0 from "./color-marker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports